export const gaSendEvent = (arg1, arg2, arg3) => {
  const { ga } = window;
  ga('send', 'event', arg1, arg2, arg3)
};
